import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import NextLink from 'components/NextLink';
import styles from '../styles.module.scss';

const NavigationItem = ({
	active,
	item,
	itemRef,
	tabIndex,
	totalItems,
	indexNumber
}) => {
	const { title, url, target, rel } = item;
	const itemCx = cx(styles.item, { [styles.active]: active });

	const ariaText =
		totalItems === 1
			? title
			: `Пункт меню ${title}. ${indexNumber + 1} из ${totalItems}`;

	return (
		<li className={itemCx}>
			<NextLink
				next
				className={styles.link}
				href={url}
				ref={itemRef}
				rel={rel}
				role="menuitem"
				tabIndex={tabIndex}
				target={target}
				aria-label={ariaText}
			>
				{title}
			</NextLink>
		</li>
	);
};

NavigationItem.propTypes = {
	active: PropTypes.bool,
	item: PropTypes.shape({
		title: PropTypes.string.isRequired,
		url: PropTypes.string.isRequired,
		active: PropTypes.bool,
		target: PropTypes.string,
		rel: PropTypes.string
	}),
	itemRef: PropTypes.object,
	tabIndex: PropTypes.number,
	totalItems: PropTypes.number,
	indexNumber: PropTypes.number
};

NavigationItem.defaultProps = {
	active: false,
	item: {
		active: null,
		target: null
	}
};

export default NavigationItem;
